import { useState, useEffect } from 'react';
import { ELEMENTS_LAYER_ID } from '../components/modules/easyFloor/map/layers/Elements';

export const getRotatedElementWrapperSize = (element) => {
    const corners = getCorners(element, element.angle);

    const minX = Math.min(corners.x[0], corners.x[1], corners.x[2], corners.x[3]);
    const minY = Math.min(corners.y[0], corners.y[1], corners.y[2], corners.y[3]);
    const maxX = Math.max(corners.x[0], corners.x[1], corners.x[2], corners.x[3]);
    const maxY = Math.max(corners.y[0], corners.y[1], corners.y[2], corners.y[3]);

    return {
        'width': maxX - minX,
        'depth': maxY - minY,
        'position': {
            'x': minX,
            'y': minY
        },
        'limits': {
            'minX': minX,
            'minY': minY,
            'maxX': maxX,
            'maxY': maxY
        }
    }
};

export const getCorners = (element, angle) => {
    const angleRad = angle * Math.PI / 180;

    const x1 = Number(element.positionX);
    const y1 = Number(element.positionY);
    const x2 = Number(element.positionX) + Number(element.width);
    const y2 = Number(element.positionY);
    const x3 = Number(element.positionX) + Number(element.width);
    const y3 = Number(element.positionY) + Number(element.depth);
    const x4 = Number(element.positionX);
    const y4 = Number(element.positionY) + Number(element.depth);

    const centerX = Number(element.positionX) + Number(element.width) / 2;
    const centerY = Number(element.positionY) + Number(element.depth) / 2;

    const rotatedX1 = Number(centerX) + Number(x1 - centerX) * Number(Math.cos(angleRad)) - Number(y1 - centerY) * Number(Math.sin(angleRad));
    const rotatedY1 = Number(centerY) + Number(x1 - centerX) * Number(Math.sin(angleRad)) + Number(y1 - centerY) * Number(Math.cos(angleRad));

    const rotatedX2 = Number(centerX) + Number(x2 - centerX) * Number(Math.cos(angleRad)) - Number(y2 - centerY) * Number(Math.sin(angleRad));
    const rotatedY2 = Number(centerY) + Number(x2 - centerX) * Number(Math.sin(angleRad)) + Number(y2 - centerY) * Number(Math.cos(angleRad));

    const rotatedX3 = Number(centerX) + Number(x3 - centerX) * Number(Math.cos(angleRad)) - Number(y3 - centerY) * Number(Math.sin(angleRad));
    const rotatedY3 = Number(centerY) + Number(x3 - centerX) * Number(Math.sin(angleRad)) + Number(y3 - centerY) * Number(Math.cos(angleRad));

    const rotatedX4 = Number(centerX) + Number(x4 - centerX) * Number(Math.cos(angleRad)) - Number(y4 - centerY) * Number(Math.sin(angleRad));
    const rotatedY4 = Number(centerY) + Number(x4 - centerX) * Number(Math.sin(angleRad)) + Number(y4 - centerY) * Number(Math.cos(angleRad));

    return {
        'x': [rotatedX1, rotatedX2, rotatedX3, rotatedX4],
        'y': [rotatedY1, rotatedY2, rotatedY3, rotatedY4]
    }
}

export const getScale = (elementId) => {
    if (!elementId) return 1;
    const container = document.getElementById(ELEMENTS_LAYER_ID).parentElement;
    const transformStyle = container.style.getPropertyValue('transform');
    const pattern = /scale\([0-9].*?\)/g;
    const stylesScale = transformStyle.match(pattern);
    const scale = stylesScale[0].replace('scale(', '').replace(')', '');
    return (scale ? Number(scale) : 1);
}

export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay)

        return () => {
            clearTimeout(handler);
        }
    }, [value, delay]);

    return debouncedValue;
}

export const checkIfModuleEnabled = async (modules, moduleName) => {
    //return false;
    let isEnabled = false;

    if(!modules || modules.length === 0) {
        return false;
    }
    
    modules.forEach(function (module) {
        if(module.name === moduleName) {
            isEnabled = true;
        }
    })

    return isEnabled;
}

/**
 * Generates random string
 * 
 * @returns {string}
 */
export const generateUniqueString = () => {
    const now = new Date().getTime();
    const random = Math.floor(Math.random() * 9999999);
    return `${now}.${random}`;
};

const CAMERA_FOV = 45;

// deg to rad
const d2r = deg => deg * (Math.PI / 180);

/**
 * Calculates the distance of the camera
 * 
 * @param {*} param0 
 * @param {*} fit 
 * @param {*} padding 
 * @returns 
 */
export const calcCameraDistance = ({ w = 100, h = 100, d = 100 }, fit = false, padding = 10) => {    
    const angle = (180 - CAMERA_FOV) / 2;

    fit = (w >= 2100) ? false : fit;

    const b = (fit ? Math.max(w, h) : Math.min(w, h)) + padding;
    const a = b / (2 * Math.cos(d2r(angle)));

    const z = d + a * Math.sin(d2r(angle));

    return z;
};
